import React from 'react';
import '../../globalstyles.css';
import '../../App.css';
import './LandingPage.css';
import arrow from "./arrow.png"
const mobilebg = require('../../assets/mobile-bg.png');


interface LandingPageTextProps {
    setShowGraphics: (showGraphics: boolean) => void;
    showGraphics: boolean;
    showSetGraphicsButton: boolean;
}

export default function LandingPageText({
    setShowGraphics,
    showGraphics,
    showSetGraphicsButton,
}: LandingPageTextProps) {
    return (
        <div className="landing" id="landing-scroll">
            <img 
                alt="right arrow" 
                id="right-arrow" 
                src={arrow}>
                
            </img>
            <div className="position-box">
                <div className="position">
                    
                    <img
                        alt="hab logo mobile"
                        id="mobile-bg"
                        src={mobilebg}
                    ></img>

                    <p className="message"> hack@brown presents </p>

                    <h1> campfire </h1>

                    <p className="date"> jan 28 - 29, 2023</p>
                </div>
            </div>

            {/* {showSetGraphicsButton && (
                <div className="toggle-graphics">
                    <a onClick={() => setShowGraphics(!showGraphics)} href="/">
                        Toggle Graphics
                    </a>
                </div>
            )} */}
        </div>
    );
}
